<template>
	<div class="controlDom background3">
		<div class="title-top">
			<div style="display: flex;">
				<img src="../../../../static/imgV2/detail-title.png" alt="">
				<div class="title-top-text">{{ languageJson.Remote }}</div>
			</div>
			<img style="float: right;width: 1.5vw;cursor: pointer;z-index: 9;" src="../../../../static/imgV2/closeIcon.png" alt="" @click="ifControlClear()">
		</div>
		<div style="display: flex;width: 92%;margin: 10px auto;justify-content: space-between;cursor: default;">
			<div style="background: #122279;border-radius: 8px;width: 48%;display: flex;flex-direction: column;">
				<div class="control-title">{{ languageJson.robotControlTime }}</div>
				<div style="text-align: center;font-weight: 800;font-size: 1vw;">
					<span v-if="timeVo.hour < 10">0</span>{{ timeVo.hour }}:
					<span v-if="timeVo.minute < 10">0</span>{{ timeVo.minute }}:
					<span v-if="timeVo.second < 10">0</span>{{ timeVo.second }}
				</div>
				<div v-if="robotInfo.robotType == '02'" style="text-align: center;margin: 1vw auto;">
					<div style="margin: 0.5vw;">{{ languageJson.RemoteControlSpeed }}</div>
					<el-radio v-model="radioValue" label="1">{{ languageJson.normal }}</el-radio>
					<div style="height: 0.3vw;"></div>
					<el-radio v-model="radioValue" label="2">{{ languageJson.lowSpeed }}</el-radio>
				</div>
			</div>
			<!-- -------室外机隐藏机器人行动控制】模块    室内机正常显示 -------->
			<div style="background: #122279;border-radius: 8px;width: 48%;padding-bottom: 0.5vw;" v-if="['04','05','06','07'].includes(robotInfo.robotType) ">
				<div class="control-title">{{ languageJson.robotActionControl }}</div>
				<div style="text-align: center;">
					<img class="direcSS" :src="positionImg_t" @mousedown="mouseFun('robot', 'top', true)" @mouseup="mouseFun('robot', 'top', false)" alt="">
				</div>
				<div style="text-align: center;">
					<img class="direcSS" :src="positionImg_l" @mousedown="mouseFun('robot', 'left', true)" @mouseup="mouseFun('robot', 'left', false)" alt="">
					<img class="direcSS" :src="positionImg_b" @mousedown="mouseFun('robot', 'bottom', true)" @mouseup="mouseFun('robot', 'bottom', false)" alt="">
					<img class="direcSS" :src="positionImg_r" @mousedown="mouseFun('robot', 'right', true)" @mouseup="mouseFun('robot', 'right', false)" alt="">
				</div>
				<div class="directionDom"><span>W</span><div class="PTVdirection">{{ languageJson.forward }}</div></div>
				<div class="directionDom"><span>S</span><div class="PTVdirection">{{ languageJson.retreat }}</div></div>
				<div class="directionDom"><span>A</span><div class="PTVdirection">{{ languageJson.turnLeft }}</div></div>
				<div class="directionDom"><span>D</span><div class="PTVdirection">{{ languageJson.turnRight }}</div></div>
			</div>
		</div>
		<div  style="width: 92%;background: #122279;border-radius: 8px;margin: 1vw auto;padding: 1px 0 1vw 0;">
			<div class="control-title" style="width: 43%;">{{ languageJson.cameraAction }}</div>
			<div style="display: flex;justify-content: space-between;">
				<div style="width: 50%;display: flex;align-items: center;justify-content: center;flex-direction: column;">
					<img style="width: 3.56vw;margin-bottom: -1.33vw;cursor: pointer;" @mousedown="mouseFun('ptv', 'top', true)" @mouseup="mouseFun('ptv', 'top', false)" :src="pTZImg_t" alt="">
					<div style="margin-left: -0.05vw;">
						<img style="width: 2vw;cursor: pointer;" :src="pTZImg_l" @mousedown="mouseFun('ptv', 'left', true)" @mouseup="mouseFun('ptv', 'left', false)" alt="">
						<img style="width: 2vw;margin-left: 0.66vw;cursor: pointer;" @mousedown="mouseFun('ptv', 'right', true)" @mouseup="mouseFun('ptv', 'right', false)" :src="pTZImg_r" alt="">
					</div>
					<img style="width: 3.56vw;margin-top: -1.65vw;cursor: pointer;" @mousedown="mouseFun('ptv', 'bottom', true)" @mouseup="mouseFun('ptv', 'bottom', false)" :src="pTZImg_b" alt="">
					<div class="iconImg">
						<img :style="{'width':' 0.7vw','margin-left': languageCheck == 'English' ? '2.5vw' : '1vw'}" src="../../../../static/imgV2/icon-top.png" alt="">
						<span class="towardsUpDom">{{ languageJson.towardsUp }}</span>
					</div>
					<div class="iconImg">
						<img :style="{'width':' 0.7vw','margin-left': languageCheck == 'English' ? '2.5vw' : '1vw'}" src="../../../../static/imgV2/icon-left.png" alt="">
						<span class="towardsUpDom">{{ languageJson.towardsLeft }}</span>
					</div>
					<div class="iconImg">
						<img :style="{'width':' 0.7vw','margin-left': languageCheck == 'English' ? '2.5vw' : '1vw'}" src="../../../../static/imgV2/icon-bottom.png" alt="">
						<span class="towardsUpDom">{{ languageJson.towardsDown }}</span>
					</div>
					<div class="iconImg">
						<img :style="{'width':' 0.7vw','margin-left': languageCheck == 'English' ? '2.5vw' : '1vw'}" src="../../../../static/imgV2/icon-right.png" alt="">
						<span class="towardsUpDom">{{ languageJson.towardsRight }}</span>
					</div>
				</div>
				<div style="width: 50%;display: flex;align-items: center;justify-content: space-between;flex-direction: column;">
					<img style="width: 3vw;" src="../../../../static/imgV2/mouse.png" alt="">
					<div class="iconImg" style="width: 11vw;">
						<span>{{ languageJson.mouseWheel }}</span>
						<img style="width: 0.7vw;" src="../../../../static/imgV2/mouse-top.png" alt="">
						<span>{{ languageJson.PanMagnification }}</span>
					</div>
					<div class="iconImg" style="width: 11vw;">
						<span>{{ languageJson.mouseWheel }}</span>
						<img style="width: 0.7vw;" src="../../../../static/imgV2/mouse-bottom.png" alt="">
						<span>{{ languageJson.PanZoomingin }}</span>
					</div>
				</div>
			</div>
		</div>

		<div style="display: flex;width: 100%;align-items: center;justify-content: center;padding-bottom: 1vw;">
			<div v-if="robotInfo.robotType != '06'" class="btn1 btnDo" @click='reset()'>{{ languageJson.PanTiltReset }}</div>
			<div v-if="!timeEnd" class="btn1 btnDo" @click='timeStart()'>{{ languageJson.startControl }}</div>
			<div v-else class="btn1" @click='timeEndFun()'>{{ languageJson.endControl }}</div>
		</div>
	</div>
</template>

<script>
	import {
		angleControl,
		control,
		deControl
	} from '@/api/admin.js'
	import {
		getItem
	} from '@/utils/auth'

	import {
		controlCommand,
		initialize
	} from '@/api/user.js'

	export default {
		name: '',
		data() {
			return {
        timer: null,
				languageJson: languageJson,
				languageCheck: localStorage.getItem('language'),
				positionImg_t: require('../../../../static/imgV2/w.png'),
				positionImg_l: require('../../../../static/imgV2/a.png'),
				positionImg_r: require('../../../../static/imgV2/d.png'),
				positionImg_b: require('../../../../static/imgV2/s.png'),
				positionImg_top: require('../../../../static/imgV2/w.png'),
				positionImg_left: require('../../../../static/imgV2/a.png'),
				positionImg_right: require('../../../../static/imgV2/d.png'),
				positionImg_bottom: require('../../../../static/imgV2/s.png'),
				positionImg_top_check: require('../../../../static/imgV2/w-check.png'),
				positionImg_left_check: require('../../../../static/imgV2/a-check.png'),
				positionImg_right_check: require('../../../../static/imgV2/d-check.png'),
				positionImg_bottom_check: require('../../../../static/imgV2/s-check.png'),
				pTZImg_t: require('../../../../static/imgV2/top.png'),
				pTZImg_l: require('../../../../static/imgV2/left.png'),
				pTZImg_r: require('../../../../static/imgV2/right.png'),
				pTZImg_b: require('../../../../static/imgV2/bottom.png'),
				pTZImg_top: require('../../../../static/imgV2/top.png'),
				pTZImg_left: require('../../../../static/imgV2/left.png'),
				pTZImg_right: require('../../../../static/imgV2/right.png'),
				pTZImg_bottom: require('../../../../static/imgV2/bottom.png'),
				pTZImg_top_check: require('../../../../static/imgV2/top-check.png'),
				pTZImg_left_check: require('../../../../static/imgV2/left-check.png'),
				pTZImg_right_check: require('../../../../static/imgV2/right-check.png'),
				pTZImg_bottom_check: require('../../../../static/imgV2/bottom-check.png'),
				ifPTZTop: false,
				ifPTZLeft: false,
				ifPTZRight: false,
				ifPTZBottom: false,
				ifpositionTop: false,
				ifpositionLeft: false,
				ifpositionRight: false,
				ifpositionBottom: false,
				radioValue: '1',
				constTop: null,
				constLeft: null,
				postionTop: null,
				postionLeft: null,
			}
		},
		props: {
			robotInfo: null,
			timeEnd: Boolean,
			ifControl: Boolean,
			controlStatus: Boolean,
			nowTime: '',
			timeVo: null
		},
		mounted() {
			this.elementListen(this)
		},
		methods: {
			mouseFun(type, value, status) {
				if (type == 'ptv') {
					if (value == 'top') {
						this.ifPTZTop = status
					} else if (value == 'left') {
						this.ifPTZLeft = status
					} else if (value == 'right') {
						this.ifPTZRight = status
					} else if (value == 'bottom') {
						this.ifPTZBottom = status
					}
				} else if (type == 'robot') {
					if (this.timeEnd) {
						if (value == 'top') {
							this.ifpositionTop = status
						} else if (value == 'left') {
							this.ifpositionLeft = status
						} else if (value == 'right') {
							this.ifpositionRight = status
						} else if (value == 'bottom') {
							this.ifpositionBottom = status
						}
					}
				}
			},
			ifControlClear() {
				this.$emit('clear', true)
			},
			timeStart() {
				let that = this
				if (that.controlStatus) {
					that.$emit('controlType', true)
					controlCommand({
						userId: getItem('userInfo').account + '_' + that.nowTime + '_' + getItem('tenantInfoId'),
						number: that.robotInfo.number,
						operationType: '1'
					})
				}
			},
			timeEndFun() {
				let that = this
				controlCommand({
					userId: getItem('userInfo').account + '_' + that.nowTime + '_' + getItem('tenantInfoId'),
					number: that.robotInfo.number,
					operationType: '2'
				})
			},
			elementListen(that) {
				document.onkeydown = function(e) {
					if (that.timeEnd) {
						if (e.keyCode == 87) {
							that.ifpositionTop = true
						} else if (e.keyCode == 65) {
							that.ifpositionLeft = true
						} else if (e.keyCode == 68) {
							that.ifpositionRight = true
						} else if (e.keyCode == 83) {
							that.ifpositionBottom = true
						}
					}
					if (that.ifControl) {
						if (e.keyCode == 37) {
							that.ifPTZLeft = true
						} else if (e.keyCode == 38) {
							that.ifPTZTop = true
						} else if (e.keyCode == 39) {
							that.ifPTZRight = true
						} else if (e.keyCode == 40) {
							that.ifPTZBottom = true
						}
					}
				}
				document.onkeyup = function(e) {
					if (that.timeEnd) {
						if (e.keyCode == 87) {
							that.ifpositionTop = false
						} else if (e.keyCode == 65) {
							that.ifpositionLeft = false
						} else if (e.keyCode == 68) {
							that.ifpositionRight = false
						} else if (e.keyCode == 83) {
							that.ifpositionBottom = false
						}
					}
					if (that.ifControl) {
						if (e.keyCode == 37) {
							that.ifPTZLeft = false
						} else if (e.keyCode == 38) {
							that.ifPTZTop = false
						} else if (e.keyCode == 39) {
							that.ifPTZRight = false
						} else if (e.keyCode == 40) {
							that.ifPTZBottom = false
						}
					}
				}
			},
			reset() {
				let that = this
				let ajaxPost = {
					number: that.robotInfo.number,
					tenantInfoId: getItem('tenantInfoId'),
					direction: '-1'
				}
				angleControl(ajaxPost).then(() => {
					that.$emit('sliderValue', true)
				})
			},
			posTangle(type, value) {
				let that = this
				let direction = '0'
				that.constTop = that.constTop ? that.constTop : '0'
				that.constLeft = that.constLeft ? that.constLeft : '0'
				// 上下左右 1，4，2，3
				if (value) {
					if (type == '1') {
						if (that.constTop == '0') {
							that.constTop = '1'
						} else {
							return false;
						}
					} else if (type == '2') {
						if (that.constLeft == '0') {
							that.constLeft = '1'
						} else {
							return false;
						}
					} else if (type == '3') {
						if (that.constLeft == '0') {
							that.constLeft = '2'
						} else {
							return false;
						}
					} else if (type == '4') {
						if (that.constTop == '0') {
							that.constTop = '2'
						} else {
							return false;
						}
					}
				} else {
					if (type == '1' || type == '4') {
						if (that.constTop == '0') {
							return false
						} else {
							that.constTop = '0'
						}
					} else if (type == '2' || type == '3') {
						if (that.constLeft == '0') {
							return false
						} else {
							that.constLeft = '0'
						}
					}
				}

				if (that.constTop == '1') {
					if (that.constLeft == '1') {
						direction = '5'
					} else if (that.constLeft == '2') {
						direction = '6'
					} else {
						direction = '1'
					}
				} else if (that.constTop == '2') {
					if (that.constLeft == '1') {
						direction = '8'
					} else if (that.constLeft == '2') {
						direction = '7'
					} else {
						direction = '2'
					}
				} else if (that.constTop == '0') {
					if (that.constLeft == '1') {
						direction = '3'
					} else if (that.constLeft == '2') {
						direction = '4'
					} else {
						direction = '0'
					}
				}
				let ajaxPost = {
				  number: that.robotInfo.number,
				  tenantInfoId: getItem('tenantInfoId'),
				  direction
				}
        angleControl(ajaxPost).then(() => {})

			},
			posTypeCheck(type, value) {
        this.timer && clearInterval(this.timer);
				let that = this
				// 室外机器人
				if (that.robotInfo.robotType == '01' || that.robotInfo.robotType == '02' || that.robotInfo.robotType == '08' || that.robotInfo.robotType == '09') {
					let ajaxPost = {
						number: that.robotInfo.number,
						direction: type,
						terminal: '1',
						speed: Number(that.radioValue)
					}
					if (!that.timeEnd) return false
					if (value) {
            this.timer = setInterval(() => {
              control(ajaxPost).then(() => {})
            },300)
					} else {
						deControl(ajaxPost).then(res => {})
					}
				} else if (that.robotInfo.robotType == '04' || that.robotInfo.robotType == '05' || that.robotInfo.robotType == '07' || that.robotInfo.robotType == '06') {
					// 室内机器人
					let direction = 0
					that.postionTop = that.postionTop ? that.postionTop : 0
					that.postionLeft = that.postionLeft ? that.postionLeft : 0
					// 上下左右 1，2，3，4
					if (value) {
						if (type == 1) {
							if (that.postionTop == 0) {
								that.postionTop = 1
							} else {
								return false;
							}
						} else if (type == 3) {
							if (that.postionLeft == 0) {
								that.postionLeft = 1
							} else {
								return false;
							}
						} else if (type == 4) {
							if (that.postionLeft == 0) {
								that.postionLeft = 2
							} else {
								return false;
							}
						} else if (type == 2) {
							if (that.postionTop == 0) {
								that.postionTop = 2
							} else {
								return false;
							}
						}
					} else {
						if (type == 1 || type == 2) {
							if (that.postionTop == 0) {
								return false
							} else {
								that.postionTop = 0
							}
						} else if (type == 3 || type == 4) {
							if (that.postionLeft == 0) {
								return false
							} else {
								that.postionLeft = 0
							}
						}
					}

					if (that.postionTop == 1) {
						if (that.postionLeft == 1) {
							direction = 5
						} else if (that.postionLeft == 2) {
							direction = 6
						} else {
							direction = 1
						}
					} else if (that.postionTop == 2) {
						if (that.postionLeft == 1) {
							direction = 8
						} else if (that.postionLeft == 2) {
							direction = 7
						} else {
							direction = 2
						}
					} else if (that.postionTop == 0) {
						if (that.postionLeft == 1) {
							direction = 3
						} else if (that.postionLeft == 2) {
							direction = 4
						} else {
							direction = 0
						}
					}
					let ajaxPost = {
						number: that.robotInfo.number,
						direction: direction,
						terminal: '1',
						speed: Number(that.radioValue)
					}
					if (!that.timeEnd) return false
          if(direction != "0"){
            this.timer = setInterval(() => {
              control(ajaxPost).then(() => {})
            },300)
          }else{
            control(ajaxPost).then(() => {})
          }

				}
			},
		},
		watch: {
			radioValue: {
				deep: true,
				handler(val, oldVal) {
					this.$emit('changeRadio',val)
				}
			},
			ifPTZTop: {
				deep: true,
				handler(val, oldVal) {
					this.pTZImg_t = val ? this.pTZImg_top_check : this.pTZImg_top
					this.posTangle('1', val)
				}
			},
			ifPTZLeft: {
				deep: true,
				handler(val, oldVal) {
					this.pTZImg_l = val ? this.pTZImg_left_check : this.pTZImg_left
					this.posTangle('2', val)
				}
			},
			ifPTZRight: {
				deep: true,
				handler(val, oldVal) {
					this.pTZImg_r = val ? this.pTZImg_right_check : this.pTZImg_right
					this.posTangle('3', val)
				}
			},
			ifPTZBottom: {
				deep: true,
				handler(val, oldVal) {
					this.pTZImg_b = val ? this.pTZImg_bottom_check : this.pTZImg_bottom
					this.posTangle('4', val)
				}
			},
			ifpositionTop: {
				deep: true,
				handler(val, oldVal) {
					this.positionImg_t = val ? this.positionImg_top_check : this.positionImg_top
					this.posTypeCheck(1, val)
				}
			},
			ifpositionLeft: {
				deep: true,
				handler(val, oldVal) {
					this.positionImg_l = val ? this.positionImg_left_check : this.positionImg_left
					this.posTypeCheck(3, val)
				}
			},
			ifpositionRight: {
				deep: true,
				handler(val, oldVal) {
					this.positionImg_r = val ? this.positionImg_right_check : this.positionImg_right
					this.posTypeCheck(4, val)
				}
			},
			ifpositionBottom: {
				deep: true,
				handler(val, oldVal) {
					this.positionImg_b = val ? this.positionImg_bottom_check : this.positionImg_bottom
					this.posTypeCheck(2, val)
				}
			}
		}
	}
</script>

<style scoped lang="less">
	@import "../index/detail.less";
</style>



// WEBPACK FOOTER //
// src/page/robotDetail/components/control.vue